// Initialisation unique même si le snippet est rendu plusieurs fois
if (!window._headerSubmenuInit) {
  window._headerSubmenuInit = true;

  function initSubmenu(container) {
    const items = container.querySelectorAll('.menu-mobile__link-list-subitem.has-dropdown');
    items.forEach(function (item) {
      const trigger = item.querySelector('.menu-mobile__link-list-subitem-url');
      const dropdown = item.nextElementSibling;
      if (!trigger || !dropdown || !dropdown.classList.contains('menu-mobile__link-list-subitem_dropdown')) return;

      dropdown.style.overflow = 'hidden';
      dropdown.style.maxHeight = '0px';
      dropdown.style.transition = 'max-height 0.3s ease';

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const isOpen = item.classList.contains('is-open');

        // Ferme tous les autres items du même bloc
        items.forEach(function (other) {
          const otherDropdown = other.nextElementSibling;
          other.classList.remove('is-open');
          if (otherDropdown && otherDropdown.classList.contains('menu-mobile__link-list-subitem_dropdown')) {
            otherDropdown.style.maxHeight = '0px';
          }
        });

        if (!isOpen) {
          item.classList.add('is-open');
          dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
        }
      });
    });
  }

  function initAllSubmenus() {
    document.querySelectorAll('.menu-mobile__link-list-container-subitems').forEach(initSubmenu);
  }

  document.addEventListener('DOMContentLoaded', initAllSubmenus);
  document.addEventListener('shopify:section:load', initAllSubmenus);
}
